// extracted by mini-css-extract-plugin
export default {"mall_info_wrapper":"HoriMallInfo_mall_info_wrapper__dZqeN","mall_info":"HoriMallInfo_mall_info__BgI38","web_mall_info_wrapper":"HoriMallInfo_web_mall_info_wrapper__w3p03"};